module.exports = __webpack_public_path__ + "assets/img/00036.5cd3af61.png";